export default __webpack_public_path__ + "assets/models/6a51504ab550c3fb91a4f44a6d3d3df5.glb";